import type { SxProps, Theme } from '@mui/material/styles';

export const headingSx: SxProps<Theme> = {
  gap: 0.25,
  mx: 1,
};

export const titleSx: SxProps<Theme> = theme => ({
  fontWeight: theme.typography.h2.fontWeight,
  fontSize: theme.typography.h2.fontSize,
  lineHeight: theme.typography.h2.lineHeight,
  letterSpacing: theme.typography.h1.letterSpacing,
});

export const subtitleSx: SxProps<Theme> = theme => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.body1.fontWeight,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.body1.lineHeight,
  letterSpacing: theme.typography.h1.letterSpacing,
});

export const fieldWrapperSx: SxProps<Theme> = theme => ({
  borderRadius: 1,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  my: 1,
});

export const textFieldInputSx: SxProps<Theme> = theme => ({
  border: 'none',
  ':not(.Mui-disabled)&:hover': { backgroundColor: 'background.paper' },
  '&:focus': { outline: 'none' },
  pt: 1.5,
  pb: 0.5,
  px: 2,
  lineHeight: theme.typography.button.lineHeight,
  fontSize: 15,
});

export const actionsSx: SxProps<Theme> = {
  gap: 1,
  justifyContent: 'flex-end',
  backgroundColor: 'background.paper',
  p: 0.75,
};
